import { useScrollAnimation, useStaggerAnimation } from '../../../hooks/useScrollAnimation';

export default function Stats() {
  const stats = [
    { icon: 'ri-calendar-line', value: '25+', label: 'Anos de Experiência', description: 'Atuação consolidada no mercado de seguros' },
    { icon: 'ri-percent-line', value: '35%', label: 'Economia Média', description: 'Redução nos custos com seguros' },
    { icon: 'ri-user-smile-line', value: '500+', label: 'Clientes Atendidos', description: 'Empresas e pessoas físicas protegidas' },
    { icon: 'ri-star-fill', value: '98%', label: 'Satisfação', description: 'Clientes recomendam nossos serviços' }
  ];

  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();
  const { ref: gridRef, visibleItems } = useStaggerAnimation(stats.length);

  return (
    <section className="py-16 sm:py-20 lg:py-28 bg-gradient-to-br from-petrol-50 to-white" aria-labelledby="stats-heading">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <div
          ref={headerRef as React.RefObject<HTMLDivElement>}
          className={`text-center mb-12 sm:mb-16 transition-all duration-700 ease-out ${headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <div className="inline-flex items-center gap-2 bg-petrol-100 px-4 py-2 rounded-full mb-4 sm:mb-6" aria-hidden="true">
            <i className="ri-bar-chart-box-line text-petrol-700 text-base"></i>
            <span className="text-petrol-800 font-bold text-xs sm:text-sm uppercase tracking-wide">Resultados</span>
          </div>
          <h2 id="stats-heading" className="text-3xl sm:text-4xl lg:text-5xl font-bold text-petrol-900 mb-4 sm:mb-6 px-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Números Que Comprovam{' '}
            <span className="text-strategic-green-600">Nossa Autoridade</span>
          </h2>
          <p className="text-base sm:text-lg text-petrol-800 max-w-3xl mx-auto leading-relaxed px-4">
            Mais de duas décadas entregando <strong className="text-petrol-900">economia real</strong> e <strong className="text-petrol-900">proteção estratégica</strong> para nossos clientes.
          </p>
        </div>

        <div ref={gridRef as React.RefObject<HTMLDivElement>} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {stats.map((stat, index) => (
            <div
              key={index}
              className={`bg-white rounded-xl sm:rounded-2xl p-6 sm:p-8 shadow-lg hover:shadow-2xl border border-petrol-100 hover:border-strategic-green-400 text-center group transition-all duration-700 ease-out ${visibleItems[index] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
            >
              <div className="w-14 h-14 bg-gradient-to-br from-strategic-green-500 to-strategic-green-600 rounded-xl flex items-center justify-center mx-auto mb-4 sm:mb-6 group-hover:scale-110 transition-transform" aria-hidden="true">
                <i className={`${stat.icon} text-2xl sm:text-3xl text-white`}></i>
              </div>
              <div
                className="text-4xl sm:text-5xl font-bold text-petrol-900 mb-2 sm:mb-3"
                style={{ fontFamily: "'Playfair Display', serif" }}
                aria-label={`${stat.value} ${stat.label}`}
              >
                {stat.value}
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-petrol-900 mb-2 sm:mb-3">{stat.label}</h3>
              <p className="text-sm text-petrol-700 leading-relaxed">{stat.description}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
